import chantierNames from './chantier';
const base = `absence`;
const absenceShow = `${base}-show`;
const absenceShowDocument = `${base}-show_document`;
const absenceEditDocument = `${base}-edit_document`;

const basePath = chantierNames.basePath + '/' + base;

export default {
  basePath,
  base,
  show: absenceShow,
  showDocument: absenceShowDocument,
  editDocument: absenceEditDocument,
};
